import { $generateNodesFromDOM } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot, $insertNodes, LexicalEditor, LexicalNode } from "lexical";
import { useEffect } from "react";

type HtmlLoaderPluginParams = {
  content: string
}
const HtmlLoaderPlugin = ({ content }: HtmlLoaderPluginParams) => {
  const [editor] = useLexicalComposerContext();

  const loadContent = (editor: LexicalEditor, content: string) => {
    editor.update(() => {
      const dom: Document = new DOMParser().parseFromString(content, 'text/html');
      const nodes: LexicalNode[] = $generateNodesFromDOM(editor, dom);
      $getRoot().select();
      $getRoot().clear(); // removes default <p><br/><p>
      $insertNodes(nodes);
    });
  }

  useEffect(() => {
    loadContent(editor, content);
  }, []);

  return null
}

export default HtmlLoaderPlugin
